import { useUser } from "@/components/SupabaseProvider";
import { PlusIcon } from "@heroicons/react/20/solid";
import { ComponentPropsWithoutRef, FC, cloneElement } from "react";
import { REVIEW_USER_EMAILS } from "../const/webConst";
import { useConnectAccountPoll } from "../hooks/useConnectAccountPoll";
import { SocialProviderType } from "../types/models";
import { providerTypeToIconLabel } from "./AddSocialProviderAccountButton";

type NotConnectedSocialSocialProviderAccountAvatarProps = {
  provider: SocialProviderType;
} & ComponentPropsWithoutRef<"button">;

// Providers awaiting release; REVIEW_USER_EMAILS accounts bypass this gate.
export const COMING_SOON_PROVIDERS: SocialProviderType[] = [];

const NotConnectedSocialProviderAccountAvatar: FC<
  NotConnectedSocialSocialProviderAccountAvatarProps
> = ({ provider, ...rest }) => {
  const { connect } = useConnectAccountPoll();
  const user = useUser();
  const comingSoonProviders = REVIEW_USER_EMAILS.includes(user?.email ?? "")
    ? []
    : COMING_SOON_PROVIDERS;

  const isReview = REVIEW_USER_EMAILS.includes(user?.email ?? "");

  if (isReview)
    return (
      <button
        {...rest}
        disabled={comingSoonProviders.includes(provider)}
        data-tooltip-content={
          comingSoonProviders.includes(provider) ? "Coming soon" : "Connect"
        }
        data-tooltip-id="global"
        className={`${rest.className} p-1 w-12 h-12 relative cursor-pointer`}
        onClick={() => connect(provider)}
      >
        <div
          className={`absolute top-0 right-0 w-10 h-10 border border-dashed border-slate-200 flex items-center justify-center rounded-full`}
        >
          <PlusIcon className="w-4 h-4 text-slate-500" />
        </div>

        <div className="absolute left-0 bottom-0 bg-white border border-slate-200 p-0.5 rounded-lg">
          {cloneElement(providerTypeToIconLabel[provider].icon, {
            className: `${providerTypeToIconLabel[provider].icon.props.className} w-5 h-5`,
          })}
        </div>
      </button>
    );
  return (
    <button
      {...rest}
      disabled={comingSoonProviders.includes(provider)}
      data-tooltip-content={
        comingSoonProviders.includes(provider) ? "Coming soon" : "Connect"
      }
      data-tooltip-id="global"
      className={`${rest.className} p-1 w-10 h-10 relative cursor-pointer`}
      onClick={() => connect(provider)}
    >
      <div
        className={`absolute inset-0 w-10 h-10 border border-dashed border-slate-200 flex items-center justify-center rounded-full`}
      >
        <PlusIcon className="w-4 h-4 text-slate-500" />
      </div>

      <div className="absolute left-0 bottom-0 bg-white border border-slate-200 p-0.5 rounded-md w-5 h-5">
        {providerTypeToIconLabel[provider].icon}
      </div>
    </button>
  );
};

export default NotConnectedSocialProviderAccountAvatar;
